import { Helmet } from 'react-helmet-async'

export function AnimeIndexHelmet() {
  const siteUrl = 'https://www.anizone.co.il/animes'
  const siteName = 'AniZone'
  const title = 'AniZone - אנימות'
  const description =
    'דפדפו בין מאות אנימות באתר אניזון (AniZone) – סינון לפי ז’אנרים, דירוגים, עדכונים שוטפים וקהילה ישראלית חמה של אוהבי אנימה.'
  const keywords =
    'אנימה, מנגה, אנימה בעברית, אנימה ישראל, אנימה בישראל, מנגה בעברית, צפייה באנימה, צפייה ישירה, סדרות יפניות, כתבות אנימה, חדשות אנימה, המלצות אנימה, ביקורות אנימה, דירוגי אנימה, רשימת צפייה, AniZone, אניזון, קהילת אנימה, קהילת מנגה, פאנסאב ישראל, פאנסאב אנימה, אנימה לצפייה, לוח שידורים אנימה, עונות אנימה, אנימה מתורגמת, אנימה מדובבת, אנימה מומלצת, אתר אנימה, בלוג אנימה, אתר מנגה, קבוצות פאנסאב, מדריכי אנימה, דירוג מנגות, מדריך צפייה, צפייה לפי עונה, פרופיל אנימה אישי, קהילת otaku, otaku ישראל, anime israel, manga israel, anime in hebrew, hebrew anime community, watch anime in hebrew'
  const image =
    'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/logo-1747045147075.webp'

  return (
    <Helmet>
      {/* 🧠 SEO בסיסי */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={siteUrl} />

      {/* 📱 Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />

      {/* 🐦 Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={siteUrl} />
    </Helmet>
  )
}
